// WebMCP, as a second door for browser-resident agents. The API is an early preview and its shape
// may change, so everything here is guarded and nothing in the game depends on it. The real door is
// the stateless MCP endpoint at /mcp, which any agent with HTTP can use.

interface ModelContextLike {
  registerTool?: (tool: { name: string; description: string; inputSchema: Record<string, unknown>; execute: (args: Record<string, unknown>) => Promise<unknown> }) => unknown;
}

export interface WebMcpBridge {
  state(): unknown;
  takeShot(args: { club: string; aimDeg: number; power: number; spin?: number }): Promise<unknown>;
  askCaddie(): Promise<unknown>;
}

export function registerWebMCP(bridge: WebMcpBridge): boolean {
  const nav = navigator as unknown as { modelContext?: ModelContextLike };
  const doc = document as unknown as { modelContext?: ModelContextLike };
  const mc = nav.modelContext ?? doc.modelContext;
  if (!mc || typeof mc.registerTool !== 'function') return false;
  try {
    mc.registerTool({
      name: 'links_room_state',
      description: 'The state of the golf room open in this tab.',
      inputSchema: { type: 'object', properties: {} },
      execute: async () => bridge.state(),
    });
    mc.registerTool({
      name: 'links_take_shot',
      description: 'Play a stroke in this tab. club: driver|wood|iron5|iron7|iron9|wedge|putter; aimDeg -180..180 (0 is down the hole); power 0..1.',
      inputSchema: { type: 'object', properties: { club: { type: 'string' }, aimDeg: { type: 'number' }, power: { type: 'number' }, spin: { type: 'number' } }, required: ['club', 'aimDeg', 'power'] },
      execute: async (args) => bridge.takeShot(args as { club: string; aimDeg: number; power: number; spin?: number }),
    });
    mc.registerTool({
      name: 'links_ask_caddie',
      description: 'Ask Dex, the caddie, what he would play from here.',
      inputSchema: { type: 'object', properties: {} },
      execute: async () => bridge.askCaddie(),
    });
    return true;
  } catch {
    return false;
  }
}
